import { Accordion, Button, FilterCheckbox, FilterCheckboxInline, Flex, INNER_MAX_WIDTH, Text } from '@capioweb/ui-components/src'
import React from 'react'
import AnimateHeight from 'react-animate-height'
import { LocalesContext } from '../../../context'
import { ArticleFilterValue, Articles } from '../ContentHubArticleListingBlock'
import { ArticleFilterContext } from '../context/ArticleFilterContext'

interface FilterSectionProps {
    heading?: string
    filterValues: ArticleFilterValue[]
    lastChild?: boolean
    i: number
}

const FilterSection: React.FC<FilterSectionProps> = ({
    heading,
    filterValues,
    lastChild,
    i

}) => {

    const { activeArticleIds, updateActiveArticleIds, checkCategory } = React.useContext(ArticleFilterContext)

    const { translate, translationKeys } = React.useContext(LocalesContext)

    return (
        <Flex
            w={1}
            flexDirection="column"
            pb={1.5}
            mb={{ _: 0, l: lastChild ? 2 : 3 }}
            borderBottom={lastChild ? false : { _: false, l: true }}
            key={heading + i}
        >
            <Flex >

                {heading && (
                    <Text
                        display={{ _: "none", l: "flex" }}
                        fontSize={1.75}
                        lineHeight={2.5}
                        fontWeight="bold"
                        letterSpacing="1px"
                        textTransform="uppercase"
                        mb={1.5}
                    >
                        {heading}
                    </Text>
                )}
                <Flex position={{ _: 'relative', m: 'static' }} mt={{ _: 1, m: 0 }} left={{ _: '-6px', m: 0 }}>
                    <FilterCheckboxInline label={translate(translationKeys.checkAll)} onChange={(event) => {
                        checkCategory(event.target.checked, heading)
                    }} />
                </Flex>
            </Flex>
            {filterValues?.length > 0 && (
                <Flex w={1} flexWrap="wrap">
                    {filterValues.map((filter) => {
                        return (
                            <Flex pb={1.5} pr={1.5} key={filter.id}>
                                <FilterCheckbox
                                    checked={
                                        activeArticleIds.includes(Number(filter.id))
                                    }
                                    label={filter.name}
                                    value={filter.id.toString()}
                                    onChange={() => updateActiveArticleIds(Number(filter.id))}
                                    withoutBorder={false}
                                />
                            </Flex>
                        )
                    })}
                </Flex>
            )}
        </Flex>
    )
}

interface ArticleListProps {
    articles: Articles
}

const ArticleFilter: React.FC<ArticleListProps> = ({ articles }) => {
    const { translate, translationKeys } = React.useContext(LocalesContext)
    const { isLoading } = React.useContext(ArticleFilterContext)
    // Toggle for filter
    const [filterOpen, setFilterOpen] = React.useState(false)

    if (articles.filters.length <= 0) return null

    return (
        <>
            <Flex w={1} justifyContent="center" >
                <Button
                    disabled={isLoading}
                    variant="ghost-navy"
                    icon="filter"
                    textColor="navy"
                    onClick={() => {
                        setFilterOpen(!filterOpen)
                    }}
                >
                    {`${filterOpen
                        ? translate(translationKeys.close)
                        : translate(translationKeys.open)
                        } ${translate(translationKeys.filter)}`}
                </Button>
            </Flex>
            <AnimateHeight height={filterOpen ? "auto" : 0}>
                <Flex w={1} px={3} mt={2}>
                    <Flex w={1} flexDirection="column" maxw={INNER_MAX_WIDTH} m="0 auto">
                        {/* Filter layout for screens >= l */}
                        <Flex w={1} display={{ _: "none", l: "block" }}>
                            {articles.filters.map((filter, i) => {
                                return (
                                    <FilterSection
                                        heading={filter.key}
                                        filterValues={filter.value}
                                        lastChild={i === articles.filters.length - 1}
                                        i={i}
                                    />
                                )
                            }
                            )}

                        </Flex>

                        {/* Filter layout for screens < l */}
                        <Flex
                            w={1}
                            display={{ _: "flex", l: "none" }}
                            flexDirection="column"
                            pb={4.5}
                        >
                            <Accordion>
                                {articles.filters.map((filter, i) => {
                                    return (
                                        <>
                                            <Accordion.Header id={filter.key + i} noBackground>
                                                <Text fontSize={2.5} lineHeight={3} fontWeight="bold" mb={0}>
                                                    {filter.key}
                                                </Text>
                                            </Accordion.Header>
                                            <Accordion.Panel id={filter.key + i} noBackground >
                                                <FilterSection
                                                    heading={filter.key}
                                                    filterValues={filter.value}
                                                    lastChild={i === articles.filters.length - 1}
                                                    i={i}
                                                />
                                            </Accordion.Panel>
                                        </>
                                    )
                                })}

                            </Accordion>
                        </Flex>
                    </Flex>
                </Flex>
            </AnimateHeight>
        </>
    )
}
export { ArticleFilter }